/* eslint-disable no-use-before-define */
import styled from 'styled-components'
import { BlogThreshold as Threshold } from '../../constants/theme'
import Colors from '../../constants/colors'

export const PodcastBase = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-bottom: 60px;
 
  .pictureWrapper {
    position: relative;
    width: 500px;
    height: 500px;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 10px 10px 10px 0;

    :hover {
      .picture {
        transform: scale(1.1);
      }
    }
    
    .picture {
      height: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      transition: 0.3s;
      border-bottom-left-radius: 30px;
    }
  }
  
  .cornerImg {
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 50%;
  }
  
  @media (max-width: ${Threshold.tablet}) {
    flex-direction: column;
    margin-bottom: 40px;
    
    .pictureWrapper {
      width: 100%;
      height: 150px;
    }

  }
`

export const PodcastContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 30px 0 0 50px;
  color: #000;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  overflow-wrap: break-word;
  word-break: break-word;
  
  h2 {
    margin-bottom: 25px;
    font-family: StolzlMedium, sans-serif;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  
  .podcastDescription {
    margin-bottom: 20px;
    color: ${Colors.text};
    p {
      margin: 0;
      color: inherit;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }
  }
  
  @media (max-width: ${Threshold.tablet}) {
    padding: 0;
    padding-top: 24px;
    h2 {
      margin-bottom: 20px;
    }
    .podcastDescription {
      margin-bottom: 24px;
    }
  }
`

export const PodcastHeader = styled.div`
  margin-bottom: 33px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  
  .episodesCount {
    margin-right: auto;
    font-family: StolzlMedium, sans-serif;
    color: ${Colors.primary};
    text-transform: uppercase;
  }

  @media (max-width: ${Threshold.tablet}) {
    margin-bottom: 15px;
    .socials {
      display: none;
    }
  }
  
`

export const Hosts = styled.div`
  margin-top: auto;
  
  .title {
    margin-bottom: 20px;
    font-family: StolzlMedium, sans-serif;
    color: ${Colors.primary};
    text-transform: uppercase;
  }

  @media (max-width: ${Threshold.phone}) {

  }
`

export const HostItem = styled.div`
  display: flex;
  flex-direction: row;
  
  &+& {
    margin-top: 25px;
  }
  
  img {
    width: 50px;
    height: 50px;
    margin-right: 20px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 20px;
  }
  
  .name {
    font-family: StolzlMedium, sans-serif;
    font-size: 14px;
  }
  
  .text {
    font-size: 12px;
  }

  @media (max-width: ${Threshold.phone}) {
    img {
      margin-right: 15px;
    }
  }
`

export const EpisodesSection = styled.section`
  display: flex;
  box-sizing: border-box;
  margin-bottom: 20px;
  
  h2 {
    display: block;
    align-self: flex-start;
    width: 482px;
    padding-left: 13px;
    padding-bottom: 32px;
    flex-shrink: 0;
    text-transform: uppercase;
    border-bottom: 1px solid #D2DAE4;
  }
  
  .episodes {
    flex-grow: 1;
    margin-left: 68px;
  }

  @media (max-width: ${Threshold.tablet}) {
    flex-direction: column;
    
    h2 {
      width: auto;
      border: none;
      padding: 0;
      margin-bottom: 30px;
    }
    
    .episodes {
      margin-left: 0;
    }
  }
`

export const EpisodeBase = styled.article`
  position: relative;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 23px 50px 37px 50px;
  
  &+& {
    margin-top: 15px;
  }
  
  .episodeMeta {
    margin-bottom: 15px;
    font-family: StolzlMedium, sans-serif;
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${Colors.primary};
  }

  h3 {
    margin-bottom: 15px;
  }

  .episodeDescription {
    margin-bottom: 34px;
    color: ${Colors.text};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    
    p {
      margin: 0;
      color: inherit;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }
  }
  
  .iframeWrapper {
    iframe {
      border-radius: 10px;
    }
  }

  @media (max-width: ${Threshold.tablet}) {
    padding: 23px 25px 35px 25px;

    &+& {
      margin-top: 20px;
    }
  }

  @media (max-width: ${Threshold.phone}) {
  }
  
`
